var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",class:[{'validate-error':!_vm.validateResult}, _vm.align],on:{"click":_vm.imgClickHandle}},[_c('img',{style:({height:_vm.height+'px'}),attrs:{"src":_vm.value,"name":_vm.field}})])}
var staticRenderFns = []

export { render, staticRenderFns }